const DEFAULT_LOCALE = 'zh-TW';

const DEFAULT_LINKS = {
  serviceInstruction: 'https://www.cyintell.com/product/cloud',
  pricing: 'https://www.cyintell.com/home',
  documentation: 'https://drive.google.com/file/d/1MXS6ib7mZp1oPzIZpW70rwZIOlrTGZbW/view'
};

export const getNavigationLinks = ({ isAdmin, locale }) => {
  if (!isAdmin) return DEFAULT_LINKS;

  const lang = locale === 'en' ? 'en' : DEFAULT_LOCALE;

  return {
    serviceInstruction: `https://www.cyintell.com/learn-more?lang=${lang}&section=platform`,
    pricing: `https://www.cyintell.com/contact?lang=${lang}`,
    documentation: `https://www.cyintell.com/learn-more?lang=${lang}`
  };
};
